/**
 * @generated SignedSource<<c08f9fb961f6287dffc967de56bf762b>>
 * @relayHash 6a1e32c75dad055c6ca8fad74d4c531c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d022d1e1ba3b7fd0a79653f27f0df50e93144573f204ecb27a1e3e6f3723b092

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type uiIssueRealtimeUpdatesIssueUpdatedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type uiIssueRealtimeUpdatesIssueUpdatedSubscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type uiIssueRealtimeUpdatesIssueUpdatedSubscription = {
  response: uiIssueRealtimeUpdatesIssueUpdatedSubscription$data;
  variables: uiIssueRealtimeUpdatesIssueUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueUpdatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueUpdatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiIssueRealtimeUpdatesIssueUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiIssueRealtimeUpdatesIssueUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d022d1e1ba3b7fd0a79653f27f0df50e93144573f204ecb27a1e3e6f3723b092",
    "metadata": {},
    "name": "uiIssueRealtimeUpdatesIssueUpdatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "28be613e90f77307c93c95c277c2ef81";

export default node;
